export const enum ModalType {
  QUEST = 'QUEST',
  LEVEL_UP = 'LEVEL_UP',
  NOTIFICATION = 'NOTIFICATION',
}
